import { Spinner } from "@visiblethread/react-components";
import { LOGIN } from "constants/routes";
import { any } from "prop-types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { initializeAddInSession } from "slices/addIn/authentication/actions";
import {
  selectAddInIsInitialized,
  selectAddInIsLoggedIn,
} from "slices/addIn/authentication/selectors";
import { loadFeatureFlags } from "slices/featureFlags";

const SessionProvider = ({ children }) => {
  const isInitialized = useSelector(selectAddInIsInitialized);
  const isLoggedIn = useSelector(selectAddInIsLoggedIn);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(initializeAddInSession());
  }, []);

  useEffect(() => {
    if (isInitialized && !isLoggedIn) {
      navigate(LOGIN);
    }
  }, [isInitialized, isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(loadFeatureFlags());
    }
  }, [isLoggedIn]);

  return isInitialized ? children : <Spinner fullScreen size="62px" />;
};

SessionProvider.propTypes = {
  children: any,
};

export default SessionProvider;
